import { metricHasValue } from "./metric-has-value.pipe";

/**
 * Formats assessment metric value string as number or empty state if value is missing
 */
export function assessmentMetricValueOrNull(value?: number | string | null): string {
	return metricHasValue(value) ? `${value}` : '--';
}
